import { atom } from '@reatom/framework'

export type UserPremiumTab = 'active' | 'past' | 'purchase-history'

export const userPremiumTabAtom = atom<UserPremiumTab>(
  'active',
  'userPremiumTabAtom',
)
